import React, { createContext, useState } from 'react';

const DashboardContext = createContext();

const DashboardProvider = ({ children }) => {
    const [page, setPage] = useState('home');

    return (
        <DashboardContext.Provider value={{ page, setPage }}>
            {children}
        </DashboardContext.Provider>
    );
};

export { DashboardContext, DashboardProvider };